import React, { useRef, useEffect, useState } from 'react'
import { Button } from 'antd'
import classNames from 'classnames'
import { observer, useLocalObservable } from 'mobx-react-lite'
import { useRouter } from 'next/router'
import { useTranslation } from '@/libs/next-lang'
import IconSvg from '@/components/IconSvg'
import globalStore from '@/globalStore'
import { getLoginStatus } from '@/utils'
import styles from './guide.module.less'

const DataGuide = () => {
  const globalMobx = useLocalObservable(() => globalStore)
  const history = useRouter()
  const videoRef = useRef(null)
  const [playIcon, setPlayIcon] = useState(true)

  const { t } = useTranslation(['data-push'])

  useEffect(() => {
    videoRef.current?.addEventListener('pause', () => {
      setPlayIcon(true)
    })
    videoRef.current?.addEventListener('play', () => {
      setPlayIcon(false)
    })
    if (videoRef.current?.paused) {
      videoRef.current?.play()
    }

    return () => {
      videoRef.current?.removeEventListener('pause', () => {
        setPlayIcon(false)
      })
      videoRef.current?.removeEventListener('play', () => {
        setPlayIcon(false)
      })
      videoRef.current = null
    }
  }, [])

  const handleBtn = () => {
    // 设置埋点数据
    localStorage.setItem('operationOrigin', 'AUTH_GUIDE_FROM_DATA_CENTER')
    const cacheLogin = !!globalMobx?.userInfo?.token || getLoginStatus()
    const targetUrl = `/media/creative?from=data`
    if (!cacheLogin) {
      // 打开登录弹框
      globalMobx.loginModalToggle(true, () => (globalMobx.targetPathUrl = targetUrl))
    } else {
      // 直接跳转
      history.push(targetUrl)
    }
  }

  return (
    <div className={styles['data-guide-page']}>
      <div className={styles['data-guide-title']}>
        <span className={styles['custom-color']}>Data</span> Center{' '}
        <span className={styles['custom-font-family']}>{t('data-push:t12')}</span>
      </div>
      <div className={styles['data-guide-main']}>
        <div className={styles['data-guide-left']}>
          <ul>
            <li className={styles['list-item-title']}>{t('data-push:t13')}</li>
            <li>
              {' '}
              <IconSvg style={{ fontSize: 14, marginRight: 9 }} type="icon-gou" />
              {t('data-push:t14')}
            </li>
            <li>
              {' '}
              <IconSvg style={{ fontSize: 14, marginRight: 9 }} type="icon-gou" />
              {t('data-push:t15')}
            </li>
            <li>
              {' '}
              <IconSvg style={{ fontSize: 14, marginRight: 9 }} type="icon-gou" />
              {t('data-push:t16')}
            </li>
          </ul>
          <div className={styles['data-instructions']}>
            <span className={styles['instructions-icon']}>
              {' '}
              <IconSvg
                style={{ width: 19, height: 22, color: 'rgba(255, 255, 255, 0.85)' }}
                type="icon-anquan"
              />
            </span>
            <span className={styles.instructions}>{t('data-push:t17')}</span>
          </div>
          <div>
            <Button className={styles.btn} onClick={handleBtn} type="primary">
              {t('data-push:t18')}
            </Button>
          </div>
        </div>
        <div className={styles['data-guide-right']}>
          <div
            className={classNames(styles['video-play-icon'], {
              [styles['hide-play-icon']]: !playIcon,
            })}
          >
            <IconSvg style={{ width: 28, height: 28 }} type="icon-bofang1" />
          </div>
          <video
            ref={videoRef}
            className="video-player"
            src="https://static.creativebooster.com/ad-web/datum.mov"
            controlsList="nodownload"
            controls
            autoPlay
            muted
          />
          <img src="https://static.creativebooster.com/ad-web/bg.png" className={styles.bg} />
        </div>
      </div>
    </div>
  )
}
export default observer(DataGuide)
